import { render, staticRenderFns } from "./FolioFamilyManager.vue?vue&type=template&id=2273d602&scoped=true&lang=pug"
import script from "./FolioFamilyManager.vue?vue&type=script&lang=js"
export * from "./FolioFamilyManager.vue?vue&type=script&lang=js"
import style0 from "./FolioFamilyManager.vue?vue&type=style&index=0&id=2273d602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273d602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VChip,VCol,VRow,VSpacer,VToolbar,VToolbarTitle})
